import { useAppSelector } from '../store'
import { Outlet, RouteObject } from 'react-router-dom'
import React from 'react'
import Login from 'components/Login'
import Error from 'components/Error'
import Home from './Home'
import Dashboard from './Dashboard'
import Market from './Market'

const Scene = () => {
  const auth = useAppSelector((store) => store.auth)
  return <>{ auth?.token ? <Outlet/> : <Login/> }</>
}
const routes: RouteObject[] = [
  {
    path: '/',
    element: <Scene/>,
    children: [ Home, Dashboard, Market ],
    errorElement: <Error/>
  }
]

export default routes
